import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';
import { EditOutlined, DeleteOutlined, CaretRightFilled } from '@ant-design/icons';
import { Col, Row, Space, Timeline, Typography } from 'antd';
import UserAvatar from 'components/new-ui/base/avatar/UserAvatar';
import { H3 } from 'components/new-ui/base/typography/styles';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import ReplyToNoteForm from './ReplyToNoteForm';
import { NoteType } from './types';

interface Props {
    note: NoteType;
    isOwnNote?: boolean;
    isReplying?: boolean;
    creatorImageUrl?: string;
    replyingNoteId?: string | null;
    hideBorderBottom?: boolean;
    onDelete?: () => void;
    onEdit?: () => void;
    onReply?: () => void;
    setReplyingNoteId?: Dispatch<SetStateAction<string | null>>;
}

const Note = ({
    note,
    isOwnNote = false,
    isReplying = false,
    replyingNoteId,
    hideBorderBottom = false,
    onDelete,
    onEdit,
    setReplyingNoteId,
    onReply,
}: Props) => {
    const { id, title, content, createdAt, createdBy } = note;

    const formattedDate = moment(createdAt).format('DD/MM/YYYY hh:mm A');

    return (
        <div style={{ borderBottom: hideBorderBottom ? 'none' : '1px solid var(--gray-4)' }}>
            <article style={{ paddingBlock: 8 }}>
                <header>
                    <Row
                        justify="space-between"
                        style={{
                            marginBottom: 8,
                        }}
                    >
                        <Col
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <UserAvatar style={{ marginRight: 8 }} size="small" userName={createdBy} />
                            <H3
                                style={{
                                    marginRight: 4,
                                }}
                            >
                                {title}
                            </H3>
                            <span
                                style={{
                                    color: 'var(--gray-7)',
                                }}
                            >
                                {formattedDate}
                            </span>
                        </Col>

                        <Col>
                            {isOwnNote ? (
                                <Space size={8}>
                                    <IconButton onClick={onEdit} icon={<EditOutlined />} tooltipText="Edit Note" />
                                    <IconButton
                                        onClick={onDelete}
                                        icon={<DeleteOutlined />}
                                        tooltipText="Delete Note"
                                    />
                                </Space>
                            ) : null}
                        </Col>
                    </Row>
                </header>
                <div style={{ paddingLeft: 32 }}>
                    <Typography.Text style={{ whiteSpace: 'pre-wrap' }}>{content}</Typography.Text>
                    {isReplying && (
                        <div
                            style={{
                                marginTop: 8,
                            }}
                        >
                            <ReplyToNoteForm onSubmit={onReply} onCancel={() => setReplyingNoteId?.(null)} />
                        </div>
                    )}
                </div>
            </article>
        </div>
    );
};

export default Note;
